import React from 'react'

import { IconTitleLinkType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { TitleSection } from './IconTitleLink.styled'
import { ToolItem } from './ToolItem/ToolItem'

export const IconTitleLink = ({ toolsTitle, subtitle, tools, mode }: IconTitleLinkType): JSX.Element => {
    return (
        <TitleSection title={toolsTitle} subtitle={subtitle} mode={mode}>
            <Grid container>
                {tools.map((item, i) => (
                    <Grid item xs={12} md={4} spacing={3} key={`${i}-${item.title}`}>
                        <ToolItem item={item} mode={mode} />
                    </Grid>
                ))}
            </Grid>
        </TitleSection>
    )
}
